import { useEffect, useState } from "react";
import { promoApi, type PublicPromo } from "@/lib/api";

// One request per page load, shared by the announcement bar and the product
// page note. The storefront is prerendered, so this is only ever read in an
// effect — at build time there is no API, and the first paint shows no promo.
let pending: Promise<PublicPromo | null> | null = null;

function load(): Promise<PublicPromo | null> {
  pending ??= promoApi
    .current()
    .then((r) => r.promo)
    // An advert that cannot load is simply not shown. The cart still gets
    // the promotion; it is decided there, not here.
    .catch(() => null);
  return pending;
}

/** The automatic promotion live right now, or null. */
export function usePromo(): PublicPromo | null {
  const [promo, setPromo] = useState<PublicPromo | null>(null);
  useEffect(() => {
    let live = true;
    void load().then((p) => {
      if (live) setPromo(p);
    });
    return () => {
      live = false;
    };
  }, []);
  return promo;
}
